<template>
<div>

  <!-- THREAD PAGES -->
  <ForumPages :normThreads="this.allThreads.totalNormalThreads" :pinnedThreads="this.allThreads.totalPinnedThreads" :forumId="forumId" />

  <div class="forums">
    <div class="forum__section_title">
      <!-- Столица — центр города -->
      <img src="../assets/nav_m.gif" /> {{htmlDecode(forumName)}}
      <!-- Отметить этот форум прочитанным · Подписаться на форум -->
      <div>
        <!-- TODO -->
      </div>
    </div>

    <!-- forum threads list table -->
    <table width="100%" class="forum__table">
      <!-- table header: Форум, Модераторы, Тем, Ответов, Обновления -->
      <tr>
        <th class="forum__th" style="min-width: 30px;"><span v-html="nbsp"></span></th>
        <th class=" forum__th" style="min-width: 28px;"><span v-html="nbsp"></span></th>
        <th width="50%" class="forum__th threadslist__th_title"><span>Название темы</span></th>
        <th width="7%" class="forum__th forum__th_center threadslist__th_title"><span>Ответов</span></th>
        <th width="14%" class="forum__th forum__th_center threadslist__th_title"><span>Автор темы</span></th>
        <th width="7%" class="forum__th forum__th_center threadslist__th_title"><span>Просмотров</span></th>
        <th width="22%" class="forum__th threadslist__th_title"><span>Обновление</span></th>
      </tr>

      <!-- PINNED THREADS -->
      <template v-if="allThreads.pinnedThreads.length > 0">
        <!-- Важные темы -->
        <tr>
          <td colspan="8" class="threadslist__pinned_title">Важные темы</td>
        </tr>
        <!-- pinned threads foreach -->
        <template v-for="thread in allThreads.pinnedThreads">
          <ThreadRow :thread="thread" />
        </template>
      </template>

      <!-- NORMAL THREADS -->

      <!-- Темы форума -->
      <tr>
        <td colspan="8" class="threadslist__pinned_title">Темы форума</td>
      </tr>
      <template v-if="allThreads.threads.length > 0">
        <!-- normal threads foreach -->
        <template v-for="thread in allThreads.threads">
          <ThreadRow :thread="thread" />
        </template>
      </template>
      <template v-else>
        <td class="threadslist__nothreads" colspan="100%">
          Не найдено ни одной темы. Возможно в этом форуме нет тем, либо они более стары и не соответствуют текущей сортировке.
        </td>
      </template>



    </table>
  </div>
  <!-- end of threads display -->

  <!-- THREAD PAGES -->
  <ForumPages :normThreads="this.allThreads.totalNormalThreads" :pinnedThreads="this.allThreads.totalPinnedThreads" :forumId="forumId" />
</div>
</template>

<script>
import ThreadRow from './ThreadRow'
import ForumPages from './ForumPages'

export default {
  components: {
    ThreadRow,
    ForumPages
  },
  props: ['allThreads', 'forumName', 'forumId'],
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "./ThreadsList.scss";
</style>
